import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { filtersConfig } from '../config';
import type { FilterStage } from '../config';

export function useFilterStage() {
  const { t } = useI18n();
  const filterStage = ref<FilterStage>(filtersConfig.FILTER_STAGES.MAIN);

  const setFilterStage = (state: FilterStage) => (filterStage.value = state);
  const isActiveStage = (state: FilterStage) => state === filterStage.value;

  const isMainStage = computed(() =>
    isActiveStage(filtersConfig.FILTER_STAGES.MAIN),
  );
  const stageTitle = computed(() => {
    switch (filterStage.value) {
      case filtersConfig.FILTER_STAGES.TIME:
        return t('search.filters.dayTime');
      case filtersConfig.FILTER_STAGES.AIRLINES:
        return t('search.filters.airlines');
      default:
        return t('search.filters.title');
    }
  });

  return {
    filterStage,
    stageTitle,
    isMainStage,
    setFilterStage,
    isActiveStage,
  };
}
